export enum SnCameraStatus {
  Inactive = 'Inactive',
  Active = 'Active',
  Up = 'Up',
  Down = 'Down',
  Pending = 'Pending',
  Unconfigured = 'Unconfigured',
  Unmanaged = 'Unmanaged',
}

export enum CameraOwnership {
  MyCameras = 'My Cameras',
  SharedWithMe = 'Shared With Me',
}

export const STATUS_GROUP: string[] = [SnCameraStatus.Up, SnCameraStatus.Down, SnCameraStatus.Unmanaged];
export const OWNERSHIP_GROUP: string[] = [CameraOwnership.MyCameras, CameraOwnership.SharedWithMe];